import { useTableStore } from "../../_stores"
import React, { useEffect } from "react"
import TableRow from "./_TableRow"
import {emptyStyles} from "@/libraries/fk-data-table"

function TableBody(props, ref) {
	if (!ref) ref = React.useRef(null)

	const tableData = useTableStore(state => state.tableData)
	const isTableLoading = useTableStore(state => state.isTableLoading)

	return <tbody className="[&_td]:transition-colors [&_tr.selected_td]:bg-primary-50 " ref={ref}>
		{/* {isTableLoading && <tr data-loader>
			{
				<td className="space-y-4 p-2" colSpan={100}>
					<ShimmerEffect />
				</td>
			}
		</tr>} */}

		{/* {!isTableLoading && tableData.map((rowData, rowIndex) => {
			const rowId = rowData[0]
			rowData = rowData.slice(1)
			return (
				<TableRow key={rowIndex} rowData={rowData} rowId={rowId} rowIndex={rowIndex} />
			)
		})} */}
		{
			tableData.length === 0 && <tr>
				<td colSpan={100} className="text-center p-4"
					dangerouslySetInnerHTML={{ __html: emptyStyles.DEFAULT }}
				></td>
			</tr>
		}
		{tableData.map((rowData, rowIndex) => {
			const rowId = rowData[0]
			rowData = rowData.slice(1)
			return (
				<TableRow key={rowIndex} rowData={rowData} rowId={rowId} rowIndex={rowIndex} />
			)
		})}
	</tbody>
}

export default React.forwardRef(TableBody)